// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
    background-color: #000000;
    padding: 1rem 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.navbar-title a {
    font-size: 1.5rem;
    font-weight: bold;
    color: white;
    text-decoration: none;
}

.navbar-title a:visited {
    font-size: 1.5rem;
    font-weight: bold;
    color: white;
    text-decoration: none;
}

.navbar-links {
    display: flex;
    gap: 2rem;
}

.nav-link {
    font-size: 1rem;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    transition: background-color 0.2s;
    color: white;
    font-weight: bold;
    text-decoration: none;
}

.nav-link:visited {
    color: white;
    font-weight: bold;
    text-decoration: none;
}

.nav-link:hover {
    background-color: rgba(255, 255,255, 0.1)
}

`, "",{"version":3,"sources":["webpack://./src/css/NavBar.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,iCAAiC;IACjC,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI;AACJ","sourcesContent":[".navbar {\n    background-color: #000000;\n    padding: 1rem 2rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.navbar-title a {\n    font-size: 1.5rem;\n    font-weight: bold;\n    color: white;\n    text-decoration: none;\n}\n\n.navbar-title a:visited {\n    font-size: 1.5rem;\n    font-weight: bold;\n    color: white;\n    text-decoration: none;\n}\n\n.navbar-links {\n    display: flex;\n    gap: 2rem;\n}\n\n.nav-link {\n    font-size: 1rem;\n    padding: 0.5rem 1rem;\n    border-radius: 4px;\n    transition: background-color 0.2s;\n    color: white;\n    font-weight: bold;\n    text-decoration: none;\n}\n\n.nav-link:visited {\n    color: white;\n    font-weight: bold;\n    text-decoration: none;\n}\n\n.nav-link:hover {\n    background-color: rgba(255, 255,255, 0.1)\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
